import React from "react";
import { ListItemText } from "@material-ui/core";
import MaterialTable from "@material-table/core";
import { Product } from "../../../../../models/Product";
import moment from "moment";
import { Person } from "../../../../../models/Person";
import { ProcessedItem } from "../../../../../models/Stocktaking";

export interface ListProcessedItemsProps {
  processedItems: ProcessedItem[];
  products: ReadonlyArray<Product>;
  administrators: ReadonlyArray<Person>;
}

export const ListProcessedItems = ({
  processedItems,
  products,
  administrators
}: ListProcessedItemsProps) => {
  return (
    <MaterialTable
      title=""
      isLoading={false}
      columns={[
        {
          title: "Product",
          field: "productNameDisplay",
          render: (row: any) => (
            <ListItemText
              primary={row.productName}
              secondary={row.gtin ?? ""}
            />
          )
        },
        {
          title: "Updated",
          field: "updatedDisplay",
          render: (row: any) => (
            <ListItemText
              primary={row.updated}
              secondary={row.administrator ?? ""}
            />
          )
        },
        {
          title: "productName",
          field: "productName",
          hidden: true,
          searchable: true
        },
        {
          title: "brandName",
          field: "brandName",
          hidden: true,
          searchable: true
        },
        {
          title: "Onshelf",
          field: "onShelf"
        },
        {
          title: "administrator",
          field: "administrator",
          hidden: true,
          searchable: true
        },
        {
          title: "updated1",
          field: "updated",
          hidden: true,
          searchable: true
        },
        {
          title: "gtin",
          field: "gtin",
          hidden: true,
          searchable: true
        }
      ]}
      data={processedItems.map((x: any) => {
        let admin = administrators.find(
          (a: Person) => a.id === x?.lastUpdatedBy
        );

        let product = products.find((p: any) => x.gtin === p.gtin);

        return {
          productName: `${product?.brandName}, ${product?.name}${
            product?.sizing.value
              ? `, ${product?.sizing.value} ${product?.sizing.unit}`
              : ""
          }`,
          gtin: x.gtin,
          updated: moment(x.updated).format("YYYY-MM-DD HH:mm"),
          administrator: admin?.name,
          onShelf: x.onShelf
        };
      })}
      options={{
        pageSize: 50
      }}
      localization={{
        header: {
          actions: ""
        }
      }}
    />
  );
};
